import axios from "axios";
import constants from "./../constants/Constants";
import { COOKIE, deleteCookie, getCookie } from "./Cookie";
import { fronturls } from "../constants/FrontendURLs";
/**
 * @name fetchApi
 * @description will fetch the data based on params supplied
 * @param {string} param
 * @param {string} method
 * @param {object} variables
 */
/**
 * @name fetchStaffApi
 * @description will fetch the data based on params supplied
 * @param {string} param
 * @param {string} method
 * @param {object} variables
 */
//function to fetch student api
const cookiesToDelete=()=>{
		deleteCookie(COOKIE.UserId, "/");
		deleteCookie(COOKIE.UserName, "/");
		deleteCookie(COOKIE.Token,"/");
		sessionStorage.clear();
}

const getRedirectRoute = () => {
		if(getCookie(COOKIE.UserType) === "1")
				return fronturls.AdminLogin
		return fronturls.StudentLogin
}

export const fetchApi = (param = null, method = null, variables = null) =>
		axios({
				method: method,
				url: `${constants.ApiUrl}${param}`,
				data: variables,
				headers: {
						Authorization: `Bearer ${getCookie(COOKIE.Token)}`
				},
		})
		.then((res) => {
				return res.data;
		})
		.catch((err) => {
				console.log("The Api error", err);
				if (err.response.data.message && err.response.data.status_code) {
						console.log(err.response.data);
				}
				let { status } = err.response;
				if (status === 401) {
						console.log("Error", err.response.data);
						if(err.response.data.error_message==="Invalid token"){
								cookiesToDelete();
								let route = getRedirectRoute();
				window.location.href = constants.BaseUrl + route;
						}
						if (err.response.data.message) {
								return err.response.data;
						} else if(err.response.data.error_message){
								return err.response.data;
						}else {
								return false;
						}
				} else if (status === 400) {
						if (err.response.data.message) {
								return err.response.data;
						}else if(err.response.data.error_message){
								return err.response.data;
						} else {
								return false;
						}
				} else {
						return false;
				}
		});

export const fetchStudentApi = (param = null, method = null, variables = null) =>
		axios({
				method: method,
				url: `${constants.StudentApiUrl}${param}`,
				data: variables,
				headers: {
						Authorization: `Bearer ${getCookie(COOKIE.Token)}`
				},
		})
				.then((res) => {
						return res.data;
				})
				.catch((err) => {
						console.log("The Api error", err);
						if (err.response.data.message && err.response.data.status_code) {
								console.log(err.response.data);
						}
						let { status } = err.response;
						if (status === 401) {
								console.log("Error", err.response.data);
								if (err.response.data.error_message === "Invalid token") {
										cookiesToDelete();
										let route = getRedirectRoute();
										window.location.href = constants.BaseUrl + route;
								}
								if (err.response.data.message) {
										return err.response.data;
								} else if (err.response.data.error_message) {
										return err.response.data;
								} else {
										return false;
								}
						} else if (status === 400) {
								if (err.response.data.message) {
										return err.response.data;
								} else if (err.response.data.error_message) {
										return err.response.data;
								} else {
										return false;
								}
						} else {
								return false;
						}
				});

export const fetchAdminApi = (param = null, method = null, variables = null) =>
		axios({
				method: method,
				url: `${constants.AdminApiUrl}${param}`,
				data: variables,
				headers: {
						Authorization: `Bearer ${getCookie(COOKIE.Token)}`
				},
		})
		.then((res) => {
				return res.data;
		})
		.catch((err) => {
				console.log("The Api error", err);
				if (err.response.data.message && err.response.data.status_code) {
						console.log(err.response.data);
				}
				let { status } = err.response;
				if (status === 401) {
						console.log("Error", err.response.data);
						if(err.response.data.error_message==="Invalid token"){
								cookiesToDelete();
								let route = getRedirectRoute();
				window.location.href = constants.BaseUrl + route;
						}
						if (err.response.data.message) {
								return err.response.data;
						} else if(err.response.data.error_message){
								return err.response.data;
						}else {
								return false;
						}
				} else if (status === 400) {
						if (err.response.data.message) {
								return err.response.data;
						}else if(err.response.data.error_message){
								return err.response.data;
						} else {
								return false;
						}
				} else {
						return false;
				}
		});
export const fetchDownloadApi = (param = null, method = null, variables = null) =>
		axios({
				method: method,
				url: `${constants.ApiUrl}${param}`,
				data: variables,
				headers: {
						Authorization: `Bearer ${getCookie(COOKIE.Token)}`
				},
				responseType: 'blob'
		})
		.then((res) => {
				return res.data;
		})
		.catch((err) => {
				console.log("The Api error", err);
				if (err.response.data.message && err.response.data.status_code) {
						console.log(err.response.data);
				}
				let { status } = err.response;
				if (status === 401) {
						console.log("Error", err.response.data);
						if (err.response.data.error_message === "Invalid token") {
								cookiesToDelete();
								let route = getRedirectRoute();
								window.location.href = constants.BaseUrl + route;
						}
						if (err.response.data.message) {
								return err.response.data;
						} else {
								return false;
						}
				} else if (status === 400) {
						if (err.response.data.message) {
								return err.response.data;
						} else {
								return false;
						}
				} else {
						return false;
				}
		});

export const fetchAdminDownloadApi = (param = null, method = null, variables = null) =>
	axios({
		method: method,
		url: `${constants.AdminApiUrl}${param}`,
		data: variables,
		headers: {
			Authorization: `Bearer ${getCookie(COOKIE.Token)}`
		},
		responseType: 'blob'
	})
		.then((res) => {
			return res.data;
		})
		.catch((err) => {
			console.log("The Api error", err);
			if (err.response.data.message && err.response.data.status_code) {
				console.log(err.response.data);
			}
			let { status } = err.response;
			if (status === 401) {
				console.log("Error", err.response.data);
				if (err.response.data.error_message === "Invalid token") {
					cookiesToDelete();
					let route = getRedirectRoute();
					window.location.href = constants.BaseUrl + route;
				}
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else if (status === 400) {
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else {
				return false;
			}
		});
export const fetchImageApi = (param = null, method = null, variables = null) =>
	axios({
		method: method,
		url: `${constants.StudentApiUrl}${param}`,
		data: variables,
		headers: {
			Authorization: `Bearer ${getCookie(COOKIE.Token)}`,
			"Content-Type": "application/json",
		},
		responseType: 'arraybuffer'
	})
		.then((res) => {
			return res;
		})
		.catch((err) => {
			console.log("The Api error", err);
			if (err.response.data.message && err.response.data.status_code) {
				console.log(err.response.data);
			}
			let { status } = err.response;
			if (status === 401) {
				console.log("Error", err.response.data);
				if (err.response.data.error_message === "Invalid token") {
					cookiesToDelete();
					let route = getRedirectRoute();
					window.location.href = constants.BaseUrl + route;
				}
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else if (status === 400) {
				if (err.response.data.message) {
					return err.response.data;
				} else {
					return false;
				}
			} else {
				return false;
			}
		});
